import { useTranslation } from 'react-i18next';

import { PageHeader } from '../../components/PageHeader';
import { AnnouncementPanel } from './AnnouncementPanel';

/**
 * Die Ankuendigungen als eigene Seite -- F3-10.
 *
 * Sie standen als Reiter in der E-Mail-Einrichtung, gehen aber nicht per
 * Mail hinaus: Ein Banner erscheint in der Bearbeitung, im Kundenportal oder
 * in beiden. Die Seite liegt deshalb bei den Kanaelen und traegt ihr eigenes
 * Recht (``announcement.write``) -- der Bearbeiter, der die Stoerung am
 * Telefon bemerkt, soll sie eintragen koennen, ohne die Postfaecher zu
 * sehen.
 */
export function AnnouncementsPage() {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('announcements.title')} subtitle={t('announcements.subtitle')} />
      <AnnouncementPanel />
    </>
  );
}
